import { useNavigate } from '@tanstack/react-router';
import React from 'react';

import { ROUTE_INDEX } from '~/app/routes';
import { cn } from '~/utils/styles';

import { ReactComponent as BackIcon } from './home.svg';

interface HomeButtonProps {
  path?: string | number;
  onClick?: () => void;
  className?: string | undefined;
}

const HomeButton = ({
  path: _path = -1,
  className,
  onClick: onClickCustom,
  ...props
}: HomeButtonProps): JSX.Element => {
  const navigate = useNavigate();

  const onClick = onClickCustom ?? (() => navigate({ to: ROUTE_INDEX, replace: true }));
  return (
    <button {...{ onClick, ...props }} className={cn('cursor-pointer', className)}>
      <BackIcon className="h-full w-full" />
    </button>
  );
};

export default HomeButton;
